class WeatherList {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.weatherList')

    if (!this.section)
      return

    this.toggle   = this.section.querySelector('.weatherList__weatherToggle')
    this.wrapper  = this.section.querySelector('.weatherList__weatherCities')
    this.items    = this.wrapper.querySelectorAll('.weatherList__weatherCity')
    this.weathers = this.section.querySelectorAll('.weatherList__weather')

    return true

  }

  setEvents() {

    this.toggle.addEventListener('click', (e) => {
    
      e.preventDefault()
      this.showCities()
    
    })

    this.items.each((item, index) => {

      item.addEventListener('click', (e) => {
      
        e.preventDefault()
        this.showWeather(index)
      
      })

    })

  }

  showCities() {

    const clickEvent = () => {

      this.wrapper.removeClass('weatherList__weatherCities--active')
      document.removeEventListener('click', clickEvent)

    }

    setTimeout(() => { document.addEventListener('click', clickEvent) }, 100)
    this.wrapper.addClass('weatherList__weatherCities--active')

  }

  showWeather(index) {

    this.weathers.removeClass('weatherList__weather--active')
    this.weathers[index].addClass('weatherList__weather--active')

  }

}